var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sleep)?_c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":_vm.type[_vm.t].img,"alt":""}}),(_vm.showTip)?_c('div',[_vm._v(_vm._s(_vm.type[_vm.t].tip))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }